import {
  Form,
  FormItem,
  Dropdown,
  Input,
  Container,
  AutoComplete,
} from '../../../../components';
import { SearchIcon } from '../../../../components/SearchBar/SearchIcon';
import { filterStatusOptions } from '../const';

type FiltersEnum = 'status' | 'url' | 'campaign_name';

type FilterProps = {
  values: Record<FiltersEnum, any>;
  onChange: (newValues: Record<FiltersEnum, any>) => void;
  campaignOptions: Array<{ value: string; label: string }>;
};

export const ScraperFilter: React.FC<FilterProps> = ({
  values,
  onChange,
  campaignOptions,
}) => {
  return (
    <Form initialValue={values} onChange={onChange}>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full min-w-0">
        <Container className="w-full min-w-0">
          <FormItem inline={false} name="url" label="URL">
            <Input
              placeholder="Search"
              inputClassName="pl-20 text-medium"
              prefix={<SearchIcon />}
              defaultSizeClass="w-full min-w-0"
            />
          </FormItem>
          <FormItem inline={false} name="campaign_name" label="Campaign Name">
            <AutoComplete
              options={campaignOptions}
              placeholder="Select campaign"
            />
          </FormItem>
        </Container>
        <Container className="w-full min-w-0 xl:min-w-[18rem]">
          <FormItem inline={false} label="Filter by Status" name="status">
            <Dropdown
              options={filterStatusOptions}
              className="w-full min-w-0"
              wrapperClassName="w-full min-w-0"
            />
          </FormItem>
        </Container>
      </div>
    </Form>
  );
};
